import { AUTH_USER, AUTH_ERROR, UNAUTH_USER } from '../constants/ActionTypes'

const INITIAL_STATE = {
	error: '',
	message: '',
	content: '',
	token: '',
	user_id: '',
	user_img: '',
	username: '',
	authenticated: false
}

export default function (state = INITIAL_STATE, action) {
	switch (action.type) {
		case AUTH_USER:
			return {
				...state,
				error: '',
				message: action.response,
				token: action.response ? action.response.data.token : '',
				user_id: action.response ? action.response.data.user_id : '',
				user_img: action.response ? action.response.data.user_img : '',
				username: action.response ? action.response.data.username : '',
				authenticated: true
			}
		case AUTH_ERROR:
			return {
				...state,
				error: action.payload.data.message
			}
		case UNAUTH_USER:
			return {
				...state,
				authenticated: false,
				error: action.payload
			}
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/reducers/auth_reducer.js